module.exports = __webpack_public_path__ + "img/头图.d0731f03.png";